var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item,i){
var _obj;
return _c('span',{key:_vm.getKey(i),class:( _obj = {}, _obj[_vm.lastElementClassName] = _vm.isLastItem(i), _obj )},[_vm._v("\n    "+_vm._s(item)+"\n    "),(!_vm.isLastItem(i))?_c('span',{staticClass:"form3-chevron-right-icon"}):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }